import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const quotes = ['Siento que tengo un llamado, pero no sé cuál es.', 'He esperado tanto que empiezo a preguntarme si me lo perdí.', 'Oro. Leo la Biblia. Sirvo. Pero por dentro me siento perdida.', '¿Y si no soy especial para Dios? ¿Y si simplemente no hay un plan para mí?'];
export function EmpathySection() {
  return <section className="py-8 px-5 bg-navy-800/30" data-id="element-32">
      <div className="max-w-lg mx-auto" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-3 text-[14px] sm:text-[15px] leading-relaxed text-cream-300/90 font-light" data-id="element-34">
          <p data-id="element-35">Hay algo que nadie te dijo sobre la espera.</p>
          <p data-id="element-36">
            No es un castigo. No es un error. No es que Dios se olvidó de ti.
          </p>
          <p className="text-cream-100 font-medium text-base" data-id="element-37">
            Es que Él te está preparando para un momento que tú todavía no
            puedes ver.
          </p>
          <p data-id="element-38">
            Y sé que eso puede sonar bonito desde afuera. Pero cuando eres tú la
            que lleva años esperando... Cuando eres tú la que ora y el cielo
            parece callado... Cuando eres tú la que ve a otras avanzar mientras
            sientes que das vueltas en círculos...
          </p>
          <p data-id="element-39">Las palabras bonitas no alcanzan.</p>
          <p className="font-serif text-lg text-gold-400 italic" data-id="element-40">
            Lo que necesitas no es otro mensaje de inspiración. Lo que necesitas
            es una revelación.
          </p>
        </motion.div>

        <Ornament className="my-6" data-id="element-41" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <h2 className="font-serif text-xl text-center text-cream-100 mb-5" data-id="element-43">
            Quizás te reconoces en alguna de estas frases...
          </h2>

          <div className="space-y-3" data-id="element-44">
            {quotes.map((quote, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-navy-800/50 border border-gold-500/10 p-3.5 rounded-sm relative overflow-hidden" data-id="element-45">
                <div className="absolute top-0 left-0 w-1 h-full bg-gold-500/30" data-id="element-46"></div>
                <p className="font-serif italic text-cream-200 text-base" data-id="element-47">
                  "{quote}"
                </p>
              </motion.div>)}
          </div>

          <div className="mt-6 text-center space-y-2" data-id="element-48">
            <p className="text-cream-300 text-sm" data-id="element-49">
              Si alguna vez pensaste algo de esto...
            </p>
            <p className="font-serif text-xl text-gold-400" data-id="element-50">
              Este devocional fue escrito para ti.
            </p>
          </div>
        </motion.div>

        <Ornament className="my-6" data-id="element-51" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-3 text-[14px] sm:text-[15px] leading-relaxed text-cream-300/90 font-light" data-id="element-52">
          <h3 className="font-serif text-xl text-cream-100 mb-3" data-id="element-53">
            El problema no es tu fe. Es que nadie te enseñó a leer tu propia
            historia.
          </h3>
          <p data-id="element-54">
            La mayoría de los devocionales te dan información bíblica. Te
            explican el texto. Te dan una reflexión. Te piden que ores.
          </p>
          <p data-id="element-55">Y mañana... sigues igual.</p>
          <p data-id="element-56">
            Porque el problema no es que no sepas lo que dice la Biblia. El
            problema es que no sabes ver cómo Dios está escribiendo TU historia
            ahora mismo.
          </p>
          <p data-id="element-57">
            No ves la conexión entre lo que viviste y lo que viene. No ves que
            cada proceso difícil fue formación, no fracaso. No ves que cada
            puerta cerrada te estaba redirigiendo, no abandonando.
          </p>
          <p className="text-gold-400 font-medium" data-id="element-58">
            Y eso — ese punto ciego — es lo que mantiene a mujeres increíbles,
            llenas de fe, sintiéndose perdidas.
          </p>
        </motion.div>
      </div>
    </section>;
}